module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_steamship-mutual.715257a1.pdf";